<template>
    <div class="page-sign d-block py-0">
        <div class="row g-0">
            <div class="col-md-7 col-lg-5 col-xl-4 col-wrapper" v-if="consent_status">
                <div class="card card-sign">
                    <div class="card-header">
                        <div class="text-center">
                            <img src="../../assets/ultratech-cement-logo.png" class="img" width="200" />
                        </div>
                        <div class="text-center">
                            <a href="#" class="text-center header-logo mt-2"><span class="title">digiTRACK
                                </span></a>
                            <a href="#" class="text-center header-logo mb-3 mt-2"><span class="title">Asset Management
                                </span></a>
                        </div>
                        <h3 class="card-title">Sign In</h3>
                        <p class="card-text">Welcome back! Please signin to continue.</p>
                    </div>
                    <div class="card-body">
                        <form @submit.prevent="login">
                            <div class="mb-4">
                                <label class="form-label">Email address</label>
                                <input type="text" tabindex="1" class="form-control"
                                    placeholder="Enter your email address" :class="{ 'is-invalid': errors.email }"
                                    v-model="user.email" ref="email" />
                                <span v-if="errors.email" class="invalid-feedback">{{ errors.email[0] }}</span>
                            </div>
                            <!-- <div class="mb-4">
                                <label class="form-label d-flex justify-content-between">Password <router-link to="/forgot_password">Forgot password?</router-link></label>
                                <input type="password" tabindex="1" class="form-control" placeholder="Enter your password" :class="{ 'is-invalid': errors.password }" v-model="user.password" />
                                <span v-if="errors.password" class="invalid-feedback">{{ errors.password[0] }}</span>
                            </div> -->

                            <div class="mb-4">
                                <label class="form-label d-flex justify-content-between">Password <router-link
                                        to="/forgot_password">Forgot password?</router-link></label>
                                <div class="input-group">
                                    <input :type="showPassword ? 'text' : 'password'" class="form-control border-end-0"
                                        v-model="user.password" :class="{ 'is-invalid': errors.password }"
                                        placeholder="Password" aria-label="Password" aria-describedby="basic-addon2"
                                        tabindex="2" />
                                    <span class="input-group-text" :class="{ 'is-invalid': errors.password }"
                                        id="basic-addon2" @click="togglePassword">
                                        <i :class="showPassword ? 'ri-eye-line' : 'ri-eye-off-line'"></i>
                                    </span>
                                    <span v-if="errors.password" class="invalid-feedback">{{ errors.password[0]
                                        }}</span>
                                </div>
                                <span v-if="errors.password" class="invalid-feedback">{{ errors.password[0] }}</span>
                            </div>

                            <button method="submit" tabindex="3" class="btn btn-primary btn-sign">Sign In</button>
                        </form>
                    </div>
                </div>
            </div>
            <div class="col-xl-12 col-wrapper" v-else>
                <div class="card card-sign" style="width: 100%;">
                    <div class="card-header">
                        <div class="text-center">
                            <img src="../../assets/ultratech-cement-logo.png" class="img" width="100" />
                        </div>
                        <div class="text-center">
                            <a href="#" class="text-center header-logo mb-3 mt-2"><span class="title">Asset
                                    Management</span></a>
                        </div>
                        <h4 class="card-title text-center">Consent Form</h4>
                    </div>
                    <div class="card-body pt-0">
                        <p class="text-align-justify mb-2">
                            UltraTech Cement (“<b>UltraTech</b>”) shall collect, use, store, transfer, or otherwise
                            process your Personal Data such as <b>name, mobile/contact number, email id</b> for the
                            purposes of
                            <b>digiTrack application login authentication, work flow management and communication of
                                alerts and deviations, (“Permitted Purpose”).</b>
                        </p>
                        <p class="text-align-justify mb-2">
                            If you wish to withdraw/rescind your consent to the usage of your Personal Data for the
                            Permitted Purpose, you may do so by clicking on [USER&gt;DETAILS&gt;CONSENT] or informing
                            [Super Admin] at
                            [digitracksupport@akxatech.com]. Upon withdrawal of your consent, UltraTech shall cease all
                            processing of your Personal Data with respect to the Permitted Purpose.
                        </p>
                        <p class="text-align-justify mb-2">
                            You can review and update your Personal Data provided to UltraTech by sending an email to
                            [digitracksupport@akxatech.com] or click on [USER&gt;DETAILS&gt;LINK] after logging into the
                            web tool.
                        </p>
                        <p class="text-align-justify mb-2">
                            <span><input type="checkbox" class="chkhgt me-2" v-model="user.consent" /></span>I, the
                            undersigned, have read the Consent Form above and fully understand contents thereof. By
                            checking the “<b>CONSENT</b>” option
                            and by pressing the “<b>ACCEPT</b>” button, I do hereby consent to UltraTech, its affiliates
                            and service providers to collect, store, use and process my Personal Data for the Permitted
                            Purpose in the manner set
                            out above.
                        </p>
                    </div>
                    <div class="card-footer m-auto">
                        <button type="button" :disabled="!user.consent" class="btn btn-sm btn-primary"
                            style="width: 200px;" @click="submit">Submit</button>
                    </div>
                </div>
            </div>
            <div class="col d-none d-lg-block"><img src="assets/img/bg1.jpg" class="auth-img" alt="" /></div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            user: {
                email: "",
                password: "",
                consent: false,
            },
            consent_status: true,
            showPassword: false,
            errors: [],
            token: "",
        };
    },
    mounted() {
        if (this.consent_status) this.$refs.email.focus();
    },
    methods: {
        togglePassword() {
            this.showPassword = !this.showPassword;
        },
        login() {
            let vm = this;
            let loader = vm.$loading.show();
            vm.$store
                .dispatch("auth", { uri: "login", data: vm.user })
                .then(function (response) {
                    loader.hide();
                    vm.user = response.data.user;
                    vm.token = response.data.token;
                    if (!response.data.consent) {
                        vm.consent_status = false;
                    } else {
                        vm.getPermissions();
                    }
                })
                .catch(function (error) {
                    loader.hide();
                    console.log(error);
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
        },

        getPermissions() {
            let vm = this;
            vm.$store.dispatch("setUser", vm.user);
            vm.$store.dispatch("setToken", vm.token);
            let uri = {
                uri: "getPermissions",
                data: {
                    role_id: vm.$store.getters.user?.role_id,
                },
            };
            let loader = vm.$loading.show();
            this.$store
                .dispatch("post", uri)
                .then((response) => {
                    loader.hide();
                    vm.$store.dispatch("setPermissions", response.data);
                    vm.$router.push("/dashboard");
                })
                .catch((error) => {
                    loader.hide();
                    vm.errors = error.response.data.errors;
                    vm.$store.dispatch("error", error.response.data.message);
                });
        },

        submit() {
            let vm = this;
            let loader = vm.$loading.show();
            vm.$store
                .dispatch("auth", { uri: "addConsent", data: vm.user })
                .then(function (response) {
                    loader.hide();
                    if (response.data.consent?.consent) {
                        vm.getPermissions();
                    }
                })
                .catch(function (error) {
                    loader.hide();
                    console.log("error", error);
                });
        },
    },
};
</script>
<style>
/* .st { */
/* background-image: linear-gradient(to right, #053aed 40%, #323335 100%)!important; */
/* background-image: linear-gradient(to right, #323335 40%, #053aed 100%)!important; */
/* background-image: linear-gradient(to right, #323335 40%, #323335 100%)!important; */
/* background-image: linear-gradient(to right, #053aed 10%, #323335 100%)!important; */
/* } */

/* .input-group .form-control.is-invalid {
    border-color: #dc3545 !important;
} */

.input-group-text.is-invalid {
    border-color: #dc3545;
}

.input-group-text {
    font-size: 16px;
    background-color: transparent;
    /* border-radius-right-top: .25rem; */
}
</style>